import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'

import {
    ListPosesInput,
    ListPosesOutput,
} from '@amzn/coral_com-amazon-ihmshephard'
import { validateRequired } from './listenerUtils'

// ========================================
// READ OPERATIONS (ViewBringUp)
// ========================================

export async function listPosesListener (message: any): Promise<ListPosesOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.listPoses(ListPosesInput.clone(params)).toPromise()
}
